import { render, staticRenderFns } from "./DeviceRecord.vue?vue&type=template&id=13f8f790&"
import script from "./DeviceRecord.vue?vue&type=script&lang=ts&"
export * from "./DeviceRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports